export default __webpack_public_path__ + "static/1288-1e68a0ce4c5d78acd70739405717f484.gif";